import { useState, type FC } from "react";
import { useCanRunAutomation } from "@/queries/automation-queries";
import { Button } from "@/components/flexkit/Button";
import { IconPlay } from "@/assets/icons/geist/IconPlay";
import { RunAutomationDialog } from "@/components/automations/RunAutomationDialog";
import type { PlainWorkflow } from "@/queries/automation-queries";

type RunAutomationButtonProps = {
    workflow: PlainWorkflow;
    variant?: "primary" | "secondary";
    children?: React.ReactNode;
    disabled?: boolean;
    "data-tracking-id"?: string;
};

export const RunAutomationButton: FC<RunAutomationButtonProps> = ({
    workflow,
    variant = "primary",
    disabled,
    children,
    "data-tracking-id": dataTrackingId,
}) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const { canRunAutomation } = useCanRunAutomation(workflow.id);

    if (!canRunAutomation) {
        return null;
    }

    return (
        <>
            <Button
                variant={variant}
                LeadingIcon={IconPlay}
                onClick={() => setIsDialogOpen(true)}
                disabled={disabled}
                data-tracking-id={dataTrackingId}
            >
                {children}
            </Button>
            <RunAutomationDialog open={isDialogOpen} onOpenChange={setIsDialogOpen} workflow={workflow} />
        </>
    );
};
